import React, {useEffect, useState} from 'react';
import {DatePicker} from "antd";

import axios from "axios";
import {API_PATH} from "../../components/const";
import dayjs from "dayjs";
import moment from "moment";

const {RangePicker} = DatePicker;
const VisitorPie4= (props) => {
    const [dataObject, setDataObject] = useState({})
    const [time, setTime] = useState(new Date());
    const month = ["Янв ","Фев ","Мар ","Апр","Май","Июн","Июл ","Авг","Сен","Окт","Ноя","Дек",]
    const dateFormat = 'YYYY-MM-DD';

    let formattedLastDay = new Date(time.getFullYear(), time.getMonth() + 1, 0);
    const getData = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-duration/date-range?start_date=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date=" +  time?.getFullYear() + "-" + Number(time?.getMonth() + 1)  + "-" +  formattedLastDay?.toString()?.slice(8, 10), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDataObject(res?.data)
            })
    }

    function onChange(date, dateString) {

        if (dateString[0] !== "" && dateString[1] !== "") {
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-duration/date-range?start_date=" + dateString[0] + "&end_date=" + dateString[1], {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setDataObject(res?.data)

                })

        } else {
            getData()
        }
    }

    useEffect(() => {
        getData()
    }, [])
    return (
        <div className="visitor-box-min">
            <div className="visitor-box-item  visitor-box-item-media">
                <div>
                    <h4 className="font-family-medium">Посещения</h4>
                </div>
                <div> 
                    <RangePicker
                        placeholder={["Дата начала", "Дата окончания"]}
                        defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}
                        style={{width: "220px", marginTop: "-4px"}}
                        format={dateFormat}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className="visitor-box-item plushr">
                <div>
                    <h1 className="font-family-medium">{Math.round(dataObject?.minDuration)}</h1>
                </div>
                <div>
                    <h3 className="upneth3">
                        Минуты
                    </h3>
                    <p className="upnet">
                        Мин. время посещения

                    </p>
                </div>
            </div>
            <div className="visitor-box-item plushr">
                <div>
                    <h1 className="font-family-medium">{Math.round(dataObject?.maxDuration)}</h1>
                </div>
                <div>
                    <h3 className="upneth3">
                        Минуты
                    </h3>
                    <p className="upnet">
                        Макс. время посещения
                    </p>
                </div>
            </div>
            <div className="visitor-box-item ">
                <div>
                    <h1 className="font-family-medium">{Math.round(dataObject?.avgDuration)}</h1>
                </div>
                <div>
                    <h3 className="upneth3">
                        Минуты
                    </h3>
                    <p className="upnet">
                        Сред. время посещения

                    </p>
                </div>
            </div>

        </div>

    );
};

export default VisitorPie4;